import React from 'react';
import useSavingsData from '~/helpers/savings-blurb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons/faHandHoldingHeart';
import RawHTML from '~/components/jsx-helpers/raw-html';
import './savings-blurb.scss';
export default function SavingsBlurb() {
    const html = useSavingsData();
    return (React.createElement("div", { className: "savings-blurb" },
        React.createElement("span", { className: "book-icon" },
            React.createElement(FontAwesomeIcon, { icon: faHandHoldingHeart })),
        React.createElement(RawHTML, { html: html })));
}
